import { getCurrencySymbol } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { formatCash } from 'src/app/util/format-cash';

@Pipe({
  name: 'appshortcurrency'
})
export class AppShortCurrencyPipe implements PipeTransform {

  transform(
    value: number,
    currencyCode: string = 'GBP'
  ): string | null {
    return getCurrencySymbol(currencyCode, 'wide') + formatCash(value, 0);
  }
}
